export default __webpack_public_path__ + "static/media/bizPrint.e1af8fde.png";